import { useMemo } from 'react';
import { useSearchParams } from 'react-router';

import { useLatest } from 'hooks/useLatest';

export function useSearchFacetSelectedValue(facetType: string) {
  const [searchParams] = useSearchParams();

  const selectedValue = useMemo(
    () => searchParams.get(facetType) ?? '',
    [facetType, searchParams],
  );

  const selectedValueRef = useLatest(selectedValue);

  return selectedValueRef.current;
}
